import { PaletteColor } from '@material-ui/core/styles/createPalette';
import { Color } from '@material-ui/core';
import muiGrey from '@material-ui/core/colors/grey';

export const primary: PaletteColor = {
  main: '#8E5082',
  light: '#9F5B92',
  dark: '#7C4672',
  contrastText: '#fff',
};

export const secondary: PaletteColor = {
  main: '#FA7009',
  light: '#FC872F',
  dark: '#EE6702',
  contrastText: '#fff',
};

export const positive: PaletteColor = {
  main: '#42A700',
  light: '#47B500',
  dark: '#3E9C01',
  contrastText: '#fff',
};

export const negative: PaletteColor = {
  main: '#DC3C37',
  light: '#E64540',
  dark: '#CB302c',
  contrastText: '#fff',
};

export const warning: PaletteColor = {
  light: '#FFFCF3',
  main: '#FFBC03',
  dark: '#F4B208',
  contrastText: '#fff',
};

export const grey: Color = {
  ...muiGrey,
  50: '#f9f9f9',
  300: '#dcdcdc',
  400: '#d5dee5',
  500: '#969696',
  700: '#535353',
  900: '#050505',
};

export const mint: PaletteColor = {
  light: '#00cdc0',
  main: '#00af9e',
  dark: '#00c5ba',
  contrastText: '#fff',
};

export const darkBlue: PaletteColor = {
  light: '#808F9A',
  main: '#2d4658',
  dark: '#1B2D3A',
  contrastText: '#fff',
};

export const white: PaletteColor = {
  light: '#fff',
  main: '#fff',
  dark: '#fff',
  contrastText: '#000',
};
